import React from 'react';

const ProgressBar = ({ percentage }) => {
  return (
    <div className="progress-container">
      <div className="progress-bar">
        <div 
          className="progress-fill" 
          style={{ width: `${percentage}%` }}
        />
      </div>
      <p className="progress-text">
        {Math.round(percentage)}% Complete
      </p>
    </div>
  );
};

export default ProgressBar;